import CircularProgress from '@mui/material/CircularProgress';

export function Loading() {
	return (
		<div className='grid h-full w-full grow place-items-center'>
			<CircularProgress />
		</div>
	);
}
